import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { EntityManager, IEntity } from '@proximus/entity-manager';
import { SimInfoResource } from '@dch/products-business-logic';
import { SimInfoEntity } from '../configs/entity.config';
import { SimInfoRequest } from '@dch/products-business-logic/src/pricing-plan/sim-info-resource.model';

@Injectable({
  providedIn: 'root',
})
export class SimInfoService {
  constructor() {}

  getSimInfo(payload: SimInfoRequest): Observable<IEntity<SimInfoResource>> {
    return EntityManager.getEntity(SimInfoEntity, { msisdn: payload.msisdn });
  }
}
